<template>
  <home-header
    :fixed="false"
    :translate-menu="translateMenu"
    :tool-menu="toolMenu"
    :user-info="userInfo"
    :group-user-info="groupUserInfo"
    :group-user-infos="groupUserInfos"
    :showlogin-out="showloginOut"
    :auth-loading="authLoading"
    :personal-menu="personalMenu"
    :active-personal-path="activePersonalPath"
    :is-show-in-roaming="false"
    :show-roaming="false"
    @navigate="openMainPath"
    @translate="openTranslate"
    @tool="openTool"
    @services="openMainPath('/index#services')"
    @partners="openMainPath('/partners')"
    @command="handleCommand"
    @institution-login="$emit('auth', '/login')"
    @login="$emit('auth', '/login')"
    @register="$emit('auth', '/register')"
    @personal-navigate="$emit('personal-navigate', $event)"
  />
</template>

<script>
import HomeHeader from './HomeHeader.vue'

export default {
  name: 'SiteHeader',
  components: { HomeHeader },
  props: {
    userInfo: { type: String, default: '' },
    groupUserInfo: { type: String, default: '' },
    groupUserInfos: { type: Array, default: () => [] },
    showloginOut: Boolean,
    authLoading: Boolean,
    personalMenu: { type: Array, default: () => [] },
    activePersonalPath: { type: String, default: '' }
  },
  data () {
    return {
      translateMenu: [
        { label: '文本翻译', desc: '支持304种语言、近4万个翻译方向', type: 'text', icon: 'el-icon-document' },
        { label: '文档翻译', desc: '一键上传，高度保留原文样式排版', type: 'doc', icon: 'el-icon-folder' },
        { label: 'AI翻译', desc: 'AI驱动，精准流畅的多语言转换', type: 'ai', icon: 'el-icon-cpu' },
        { label: '多语种翻译', desc: '保留原文译文对应关系', type: 'lange', icon: 'el-icon-collection' },
        { label: '图片翻译', desc: '粘贴图片即可识别文本快速翻译', type: 'img', icon: 'el-icon-picture-outline' },
        { label: '网页翻译', desc: '快速翻译任意网页内容', type: 'webTranslate', icon: 'el-icon-monitor' }
      ],
      toolMenu: [
        { label: '润色改写', desc: '智能润色，提升文章表达质量', action: 'polish', icon: 'el-icon-magic-stick' },
        { label: 'AI PPT', desc: 'AI一键生成专业演示文稿', action: 'aiPPT', icon: 'el-icon-data-board' },
        { label: 'RAG知识库', desc: '构建专属知识库，精准检索', action: 'rag', icon: 'el-icon-folder-opened' },
        { label: '人工翻译', desc: '汇集全球海量人才，权威翻译团队', action: 'toTransPro', icon: 'el-icon-service' },
        { label: '术语词库', desc: '设定规则，提高译文一致性', action: 'standLangSet', icon: 'el-icon-notebook-2' },
        { label: '文档转换', desc: '多格式文档互转，高保真输出', action: 'convertDoc', icon: 'el-icon-files' },
        { label: '数据分析', desc: 'AI智能抓取分析，生成RAG报告', action: 'smartClassify', icon: 'el-icon-data-analysis' },
        { label: '我的文档', desc: '翻译记录管理，便捷查找历史', action: 'mySelfDoc', icon: 'el-icon-document-copy' },
        { label: '聚合数据库检索', desc: '聚合开放获取文献，快速检索DOI、引用和PDF', action: 'scholar', icon: 'el-icon-search' }
      ]
    }
  },
  methods: {
    mainUrl (path) {
      const base = (process.env.VUE_APP_INDEX || 'https://wesitrans.com').replace(/\/$/, '')
      return `${base}${path}`
    },
    openMainPath (path) {
      this.$track('header_navigation', {target: path})
      window.location.assign(this.mainUrl(path))
    },
    openTranslate (type) {
      const typeMap = {
        text: 'txt',
        doc: 'doc',
        ai: 'AITranslate',
        lange: 'more',
        img: 'img',
        webTranslate: 'plugin'
      }
      if (typeMap[type]) {
        this.$track('header_translate_select', {target: typeMap[type]})
        this.openMainPath(`/translate?type=${typeMap[type]}`)
      }
    },
    openTool (action) {
      const routes = {
        polish: '/translate?type=polish',
        aiPPT: '/translate?type=aiPPT',
        rag: '/rag',
        standLangSet: '/translate?type=setting',
        convertDoc: '/translate?type=convert',
        smartClassify: '/smart-classify',
        mySelfDoc: '/list-pro',
        scholar: '/scholar'
      }
      if (action === 'toTransPro') {
        this.$track('header_tool_select', {action})
        this.openMainPath('/trans-pro/index')
        return
      }
      if (routes[action]) {
        this.$track('header_tool_select', {action})
        this.openMainPath(routes[action])
      }
    },
    handleCommand (command) {
      if (command === 'toCenter') {
        this.$track('header_identity_action', {action: 'personal_center'})
        this.$emit('center')
        return
      }
      this.$track('header_identity_action', {action: 'logout'})
      this.$emit('logout')
    }
  }
}
</script>
